export enum ClientApproverProfileEnum {
  DRIVER_APPROVER = "DRIVER_APPROVER",
  FLEET_ADMIN_APPROVER = "FLEET_ADMIN_APPROVER"
}
